import {useEffect, useRef, useState} from "react";
import {useAPIData} from "../context/hooks/useAPIData";
import {SET_MODAL} from "../context/actions/types";


export const Modal = () => {
    const data = useAPIData()
    const [visible, setVisible] = useState(false)
    const [title,setTitle] = useState('PLACEHOLDER TITLE')
    const [body, setBody] = useState('PLACEHOLDER BODY, PLEASE REPORT IF YOU SEE THIS')
    const modalTopRef = useRef(null)
    const hideModal = () => {
        setTimeout(() => {
            setVisible(false)
            document.body.classList.remove('overflow-hidden')
        }, 150)
    }
    const showModal = (title, body) => {
        title && setTitle(title)
        body && setBody(body)
        setVisible(true)
        document.body.classList.add('overflow-hidden')
    }
    useEffect(() => {
        data.dispatch({
            type: SET_MODAL,
            payload: showModal
        })
    }, [])

    useEffect(() => {
        modalTopRef.current.scrollTop = 0
    }, [visible])
    return (
        <div className={"modal question " + (visible ? 'modal-show' : '')}>
            <div className="modal-wrapper">
                <div className="modal-header">
                    <p>{title === 'PRINCESS RACES' ? title : `Cum pot participa la ${title}`}</p>
                    <div className="modal-close" onClick={hideModal}>×</div>
                </div>
                <div/>
                <div ref={modalTopRef} className="modal-body">
                    {body}
                </div>
            </div>
        </div>)
}